/** @prettier */

import {
  Select,
  SelectChangeEvent,
  FormControl,
  MenuItem,
  InputLabel,
  Grid,
} from '@mui/material';
import {useState} from 'react';
import {useTranslation} from 'react-i18next';

//interface import
import * as apiIF from '../../Type/api';
//Style import
import '../../css/common/common.css';

import {iconBlack} from '../../define';

/**
 * 室内機タイプ設定セレクトボックス
 * @param props props
 * @returns JSX
 */
const SLIUUnitTypeSelectBox = (props: {
  /** 空調機タイプ（set関数） */
  setUnitType: React.Dispatch<
    React.SetStateAction<
      apiIF.res.getCompositionsSLUnitByOUID['indoor-unit-informations'][0]['indoor-unit-type']
    >
  >;
  /** 初期値 */
  defaultValue?: apiIF.res.getCompositionsSLUnitByOUID['indoor-unit-informations'][0]['indoor-unit-type'];
}) => {
  const trans = useTranslation().t; //翻訳関数

  //prettier-ignore
  const [iuType, setIUType] = useState(props.defaultValue === undefined ? 'FDT' : props.defaultValue); // 室内機タイプ

  /** セレクトボックス変更時 */
  const handleChange = (event: SelectChangeEvent) => {
    setIUType(
      event.target
        .value as apiIF.res.getCompositionsSLUnitByOUID['indoor-unit-informations'][0]['indoor-unit-type']
    );
    props.setUnitType(
      event.target
        .value as apiIF.res.getCompositionsSLUnitByOUID['indoor-unit-informations'][0]['indoor-unit-type']
    );
  };

  return (
    <FormControl variant="standard">
      <InputLabel>{trans('SLIUUnitTypeSelectBox.label')}</InputLabel>
      <Select
        defaultValue={props.defaultValue}
        value={iuType}
        onChange={handleChange}
        className="gwSetting__contents__selectBox--unitTypeSelectBox">
        <MenuItem value="AC">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.AC_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.AC_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.ac')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDT">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDT_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDT_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fdt')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDTW">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDTW_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDTW_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fdtw')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDTS">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDTS_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDTS_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fdts')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDE">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDE_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDE_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fde')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDF">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDF_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDF_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fdf')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDFW">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDFW_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDFW_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fdfw')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDK">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDK_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDK_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fdk')}
            </Grid>
          </Grid>
        </MenuItem>
        <MenuItem value="FDU">
          <Grid container columnSpacing={1} alignItems="center">
            <Grid
              item
              xs="auto"
              className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer">
              <img
                className="gwSetting__contents__selectBox--unitTypeSelectBox__iconContainer__icon"
                src={iconBlack.FDU_ON.src}
                alt={`${trans(
                  `SLIUUnitTypeSelectBox.alternativeText.${iconBlack.FDU_ON.alt}`
                )}`}
              />
            </Grid>
            <Grid item xs>
              {trans('SLIUUnitTypeSelectBox.value.fdu')}
            </Grid>
          </Grid>
        </MenuItem>
      </Select>
    </FormControl>
  );
};

export default SLIUUnitTypeSelectBox;
